import { useQuery } from "@tanstack/react-query";
import { getMinutesUsage } from "../api/transcriptions";
import { useAuth } from "../contexts/AuthContext";

// Only admins can see the minutes-usage endpoint (backend is.admin gated), so this
// stays idle for everyone else rather than firing a request that will 403.
export const useSidekickMinutesUsage = () => {
  const { apiUser } = useAuth();

  return useQuery({
    queryKey: ["sidekick-minutes-usage"],
    queryFn: async () => {
      const res = await getMinutesUsage();
      return res.data.data;
    },
    enabled: !!apiUser?.is_admin,
    staleTime: 60000,
  });
};
